import React from "react";

import { Button, InputGroup, FormGroup } from "@blueprintjs/core";

import styles from "./VideoDetails.module.scss";
import Dropzone from "react-dropzone";
import { DateInput } from "@blueprintjs/datetime";
import moment from "moment";

function VideoDetails({
  thumbnail,
  onThumbnailChange,
  name,
  onNameChange,
  videoScheduledDate,
  onVideoDateChange,
  isScheduled
}) {
  const scheduledBroadcastDate = moment(videoScheduledDate);
  const currentDate = moment();
  const minScheduledDate =
    currentDate < scheduledBroadcastDate
      ? currentDate.toDate()
      : scheduledBroadcastDate.toDate();

  const maxScheduleDate =
    minScheduledDate &&
    moment(minScheduledDate)
      .add(20, "years")
      .toDate();

  return (
    <div className={styles.details}>
      {!isScheduled && (
        <>
          <img src={thumbnail} alt="thumbnail" className={styles.image} />

          <Dropzone onDrop={onThumbnailChange} accept="image/*">
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button className="filled narrow" text="Change Thumbnail" />
              </div>
            )}
          </Dropzone>

          <p>
            Your video thumbnail is usually displayed when you share a link to
            your video. We'll try and automatically pick at thumbnail, but if
            you'd like to use a different one, you can upload it here.
          </p>
        </>
      )}

      <FormGroup label="Rename Video" labelFor="video-name-input">
        <InputGroup
          placeholder="Video Title"
          value={name}
          onChange={onNameChange}
          large
          id="video-name-input"
        />
        <p>
          Your video thumbnail is usually displayed when you share a link to
          your video. We'll try and automatically pick at thumbnail, but if
          you'd like to use a different one, you can upload it here.
        </p>
      </FormGroup>

      {isScheduled && (
        <FormGroup
          label="Broadcast Date"
          helperText="Your video broadcast will start on the scheduled date."
        >
          <DateInput
            formatDate={(date) => date.toLocaleString()}
            parseDate={(date) => moment(date).toDate()}
            onChange={onVideoDateChange}
            defaultValue={scheduledBroadcastDate.toDate()}
            timePickerProps={{ useAmPm: true }}
            canClearSelection={true}
            closeOnSelection={false}
            inputProps={{ large: true }}
            minDate={minScheduledDate}
            maxDate={maxScheduleDate}
          />
        </FormGroup>
      )}
    </div>
  );
}

export default VideoDetails;
